function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/~/@babel/runtime/helpers/inheritsLoose.js
// module id = 190
// module chunks = 104158497352714 128747004913641